import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { api } from '@/lib/api';
import { useAuthStore } from './authStore';

export function RegisterPage() {
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    tenant_name: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const update = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await api.post('/auth/register', form);
      setSession(data.token, data.data);
      navigate('/');
    } catch (err: any) {
      setError(err?.response?.data?.message ?? 'No se pudo registrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <img src={`${import.meta.env.BASE_URL}favicon.svg`} alt="" className="w-10 h-10" aria-hidden="true" />
          <div>
            <h1
              className="text-lg font-medium text-notion-800 leading-tight tracking-tight"
              style={{ fontFamily: "'JetBrains Mono', 'SF Mono', Menlo, monospace" }}
            >
              notas_de_cata
            </h1>
            <p
              className="text-[11px] text-notion-500 tracking-[0.15em] uppercase mt-0.5"
              style={{ fontFamily: "'JetBrains Mono', 'SF Mono', Menlo, monospace" }}
            >
              cava · inventario · mercado
            </p>
          </div>
        </div>

        <h2 className="text-xl font-medium text-notion-800 mb-1">Crear tu cava</h2>
        <p className="text-[13px] text-notion-600 mb-6">
          Te creamos una cuenta personal y el espacio para gestionar tus vinos.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">Nombre de la cava</label>
            <input className="input" required value={form.tenant_name} onChange={update('tenant_name')} />
          </div>
          <div>
            <label className="label">Tu nombre</label>
            <input className="input" required value={form.name} onChange={update('name')} />
          </div>
          <div>
            <label className="label">Email</label>
            <input type="email" className="input" required value={form.email} onChange={update('email')} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Contraseña</label>
              <input type="password" className="input" required minLength={8} value={form.password} onChange={update('password')} />
            </div>
            <div>
              <label className="label">Confirmar</label>
              <input type="password" className="input" required minLength={8} value={form.password_confirmation} onChange={update('password_confirmation')} />
            </div>
          </div>

          {error && (
            <p className="text-[13px] text-negative bg-notion-50 border border-notion-200 px-3 py-2 rounded">
              {error}
            </p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'Creando…' : 'Crear cuenta'}
          </button>

          <p className="text-[13px] text-center text-notion-600 pt-2">
            ¿Ya tenés cuenta?{' '}
            <Link to="/login" className="text-notion-800 underline underline-offset-2">
              Ingresar
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
